import React from 'react';
import { motion } from 'framer-motion';

const SlideStudentView: React.FC = () => {
  return (
    <div className="flex flex-col h-full px-12 py-6">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-4"
      >
        <h2 className="text-4xl font-bold text-white mb-2">
          Student Learning View
        </h2>
        <p className="text-xl text-[#94a3b8]">
          Students see their progress, mastery levels, and what to learn next
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="flex-1 flex items-center justify-center"
      >
        <div
          className="rounded-2xl overflow-hidden shadow-2xl"
          style={{ border: '2px solid rgba(255, 255, 255, 0.1)' }}
        >
          <img
            src="/student_learning_view_large.jpg"
            alt="Student Learning View"
            className="object-contain"
            style={{ maxHeight: '70vh', maxWidth: '90vw' }}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default SlideStudentView;
